import { URL_PATHS } from '@constants'
import { useIsMobile } from '@hooks/useIsMobile'
import { useStore } from '@hooks/useStore'
import { GridRow, GridRowParams } from '@mui/x-data-grid'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { OvDataGrid } from 'src/components/core/ov-data-grid/ov-data-grid'
import { MobileDocumentRow } from 'src/partials/index.partials'

export const OvClientInvoicesTab = observer(() => {
  const { invoice, client } = useStore()
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const { id: clientId } = useParams()

  const handleRowClick = (params: GridRowParams) => {
    if (!params.id) return
    const path = generatePath(URL_PATHS.INVOICE_DETAIL, { id: params.id })
    return navigate(path, { state: { from: 'client', clientId } })
  }

  const CustomRow = useCallback(
    (props: any) =>
      isMobile ? (
        <MobileDocumentRow
          {...props.row}
          type="invoice"
          onRowClick={handleRowClick}
        />
      ) : (
        <GridRow {...props} />
      ),
    [isMobile, handleRowClick]
  )

  return (
    <OvDataGrid
      slots={{
        row: CustomRow,
      }}
      onRowClick={handleRowClick}
      store={invoice.data_grid}
      responsiveColumns
      params={{ client_id: client.current_client.id }}
      {...(isMobile && {
        autoHeight: true,
        getEstimatedRowHeight: () => 109,
        getRowHeight: () => 'auto',
      })}
    />
  )
})
